// *******************************************************************************
// 1.0 - Set Info-bar
// *******************************************************************************

const infoBar = document.querySelector('.info-bar');

function setInfoBarHeight() {
  if (infoBar) {
    document.body.classList.add('has-info-bar');
    const infoBarHeight = infoBar.clientHeight;
    document.body.style.setProperty('--infobarHeight', `${infoBarHeight}px`);
  }
}

window.addEventListener('resize', () => {
  setInfoBarHeight();
});

window.addEventListener('load', () => {
  setInfoBarHeight();
});
